export default {
    props: {
        deserializationCustom: {
            type: Function,
            default: undefined,
            kComposite: 'deserialization.custom'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-editor-vue-wrapper/src/KendoEditor/Deserialization.js